import { isProfileComplete } from '@echo/core';
import { useMe, useSession } from '@echo/core/react';
import { Button } from '@echo/ui-web';
import { useLingui } from '@lingui/react/macro';
import { createFileRoute, Navigate, useNavigate } from '@tanstack/react-router';
import { useState } from 'react';
import { AboutStory } from '@/components/about-story';
import { markWelcomeSeen, useWelcomeSeen } from '@/lib/welcome-store';

export const Route = createFileRoute('/about')({ component: AboutPage });

/**
 * The letter read from the welcome: "Continue to home" ends the welcome
 * like the welcome's own button does, and Back returns to Brian. Once the welcome is over
 * the letter lives under Account instead.
 */
function AboutPage() {
  const { t } = useLingui();
  const session = useSession();
  const me = useMe();
  const navigate = useNavigate();
  const seen = useWelcomeSeen();
  // "Continue to home" marks the welcome seen, which on its own re-renders into the redirect
  // below and opened the same letter again under Account — it must go home instead.
  const [leaving, setLeaving] = useState(false);
  if (leaving) return <Navigate to="/" replace />;
  if (session.status === 'unknown' || (session.status === 'authenticated' && !me.isFetched)) {
    return null;
  }
  if (session.status !== 'authenticated') return <Navigate to="/sign-in" replace />;
  if (me.data && !isProfileComplete(me.data)) return <Navigate to="/onboarding" replace />;
  if (seen) return <Navigate to="/account/about" replace />;
  return (
    <AboutStory
      onBack={() => navigate({ to: '/welcome' })}
      pinned={
        <Button
          onClick={() => {
            setLeaving(true);
            markWelcomeSeen();
          }}
        >
          {t`Continue to home`}
        </Button>
      }
    />
  );
}
